import { styled, useTheme } from '@mui/material/styles';
import {  Breakpoints, Mixins, Palette, Shadows, Theme, Transitions, ZIndex } from '@mui/material';
import { Typography } from '@mui/material/styles/createTypography';
const drawerWidth:any='300px';
interface mainProps {
    theme: {
        mixins: Mixins;
        palette: Palette;
        shadows: Shadows;
        transitions: Transitions;
        typography: Typography;
        zIndex: ZIndex;
        unstable_strictMode?: boolean;
        breakpoints:Breakpoints;
    },
    open:boolean
}
export const MainComponent = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }:mainProps) => ({
    ...(!open && {
        marginLeft:'80px',
        marginTop:'80px',
        marginRight:'1%',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: 'linear 0.3s',
        [theme.breakpoints.down(1441)]: {
            marginLeft: '80px'
        }
    }),
    ...(open && {
        marginLeft:'320px',
        marginTop:'80px',
        marginRight:'1%',
        transition: 'linear 0.3s',
        [theme.breakpoints.down(1441)]: {
            marginLeft: '265px'
        }
    })
}));